/* eslint-disable camelcase */
import request from 'superagent'
import types from '../types'
import Claim from '../../types/Claim'
import OrgClaim from '../../types/OrgClaim'

import config from '../../../package.json'
const { api_port } = config

const { protocol, hostname } = window.location
let apiUrl = `${protocol}//${hostname}:${api_port}/api`

if (api_port==='') {
  apiUrl = `${protocol}//${hostname}/api`
}

const getClaimsRequested = (type: string) => ({
  type: types.GET_CLAIMS_REQUESTED,
  payload: null,
  claimType: type
})

const getClaimsFulfilled = (data: Array<Claim>, type: string) => ({
  type: types.GET_CLAIMS_FULFILLED,
  payload: data,
  claimType: type
})

const getClaimsRejected = (error: any, type: string) => ({
  type: types.GET_CLAIMS_REJECTED,
  payload: error,
  claimType: type
})

export const getClaims = (id: number, page: number, sizePerPage: number, searchTerm: string, serviceStartDate: string | undefined, serviceEndDate: string | undefined, datePaidStartDate: string | undefined, datePaidEndDate: string | undefined, sortField: string, sortOrder: string, type: string, token: string) => {
  return (dispatch: any) => {
    dispatch(getClaimsRequested(type))
    request
      .post(`${apiUrl}/claims/${id}`)
      .set('Accept', 'application/json')
      .set('access-token',token)
      .send({
        page,
        sizePerPage,
        searchTerm,
        serviceStartDate,
        serviceEndDate,
        datePaidStartDate,
        datePaidEndDate,
        sortField,
        sortOrder,
        type
      })
      .then((response) => {
        dispatch(getClaimsFulfilled(response.body, type))
      })
      .catch((error) => {
        dispatch(getClaimsRejected(error, type))
      })
  }
}

const getOrgClaimsRequested = (type: string) => ({
  type: types.GET_ORG_CLAIMS_REQUESTED,
  payload: null,
  claimType: type
})

const getOrgClaimsFulfilled = (data: Array<OrgClaim>, type: string) => ({
  type: types.GET_ORG_CLAIMS_FULFILLED,
  payload: data,
  claimType: type
})

const getOrgClaimsRejected = (error: any, type: string) => ({
  type: types.GET_ORG_CLAIMS_REJECTED,
  payload: error,
  claimType: type
})

export const getOrgClaims = (id: number, page: number, sizePerPage: number, searchTerm: string, serviceStartDate: string | undefined, serviceEndDate: string | undefined, datePaidStartDate: string | undefined, datePaidEndDate: string | undefined, facility: string, sortField: string, sortOrder: string, type: string, token: string) => {
  return (dispatch: any) => {
    dispatch(getOrgClaimsRequested(type))
    request
      .post(`${apiUrl}/org/claims/${id}`)
      .set('Accept', 'application/json')
      .set('access-token',token)
      .send({
        page,
        sizePerPage,
        searchTerm,
        facility,
        serviceStartDate,
        serviceEndDate,
        datePaidStartDate,
        datePaidEndDate,
        sortField,
        sortOrder,
        type
      })
      .then((response) => {
        dispatch(getOrgClaimsFulfilled(response.body, type))
      })
      .catch((error) => {
        dispatch(getOrgClaimsRejected(error, type))
      })
  }
}

export const clearCSVClaims = (csvType: string) => ({
  type: types.CLEAR_CSV_CLAIMS,
  csvType
})